export default "__VITE_ASSET__BKvtCrnU__"